<template>
  <div>
    <div v-if="readOnly" class="c-quantity-input__readonly">
      {{ quantity }}
    </div>
    <div v-else class="c-quantity-input" :class="cssClass">
      <button
        v-show="showDelete"
        class="c-quantity-input__button"
        @click.prevent="() => $emit('remove')"
      >
        <i class="far fa-trash"></i>
      </button>
      <button
        v-show="!showDelete"
        class="c-quantity-input__button"
        :disabled="pQuantity <= minValue"
        @click.prevent="decrement"
      >
        <i class="far fa-minus"></i>
      </button>

      <input
        v-model="pQuantity"
        class="c-quantity-input__input"
        type="number"
        size="3"
        :min="minValue"
        :max="maxValue"
        @change="onChange"
      />

      <button class="c-quantity-input__button" @click.prevent="increment">
        <i class="far fa-plus"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuantityInput',
  props: {
    deletable: {
      type: Boolean,
      default: false
    },
    maxValue: {
      type: Number,
      default: 99
    },
    minValue: {
      type: Number,
      default: 0
    },
    quantity: {
      type: Number,
      default: 0
    },
    readOnly: {
      type: [Boolean, Number],
      default: false
    },
    cssClass: {
      type: String,
      default: ''
    },
    delay: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      debouncedEmit: this.$debounce(this.$emit, this.delay),
      pQuantity: this.quantity
    };
  },
  computed: {
    showDelete() {
      return this.deletable && this.pQuantity <= this.minValue;
    }
  },
  watch: {
    quantity(val) {
      this.pQuantity = val;
    }
  },
  methods: {
    decrement() {
      if (this.isValidNumber(this.pQuantity - 1)) {
        this.debouncedEmit('change', --this.pQuantity);
      }
    },
    increment() {
      if (this.isValidNumber(this.pQuantity - -1)) {
        // strangely +1 doesn't work hence - -1
        this.debouncedEmit('change', ++this.pQuantity);
      }
    },
    onChange() {
      if (this.isValidNumber(this.pQuantity)) {
        this.$emit('change', Number(this.pQuantity));
        return;
      }

      this.pQuantity = this.quantity;
    },
    isValidNumber(value) {
      if (value === '') return false;
      const quantity = Number(value);
      return quantity >= this.minValue && quantity <= this.maxValue;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/src/utilities/_variables.scss';
@import '@/css/src/utilities/_mixins.scss';
@import '~bootstrap/scss/mixins';

.c-quantity-input {
  display: inline-flex;
  align-items: center;

  &__readonly {
    padding-left: 30px;
    width: 93px;
    font-weight: $font-weight--bold;
    text-align: center;
  }

  &__button {
    @include button-reset();
    width: 30px;
    height: 30px;
    color: $white;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $dark;

    &:disabled {
      background-color: $grey-200;
      color: rgba($dark, 0.8);
      cursor: not-allowed;
    }
  }

  &__input {
    background: transparent;
    text-align: center;
    margin: 0;
    padding: 0;
    border: 0;
    flex-grow: 1;
    min-width: 0;
    -moz-appearance: textfield;
    font-weight: $font-weight--bold;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}
</style>
